import { useMemo } from "react"
import services from "../../../services/services";
import { Urls } from "../../../services/Urls";
import _ from "underscore";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import globalFilterStore from "../../../Store/globalFilterStore";

export const useCommon = () => {
    const store = globalFilterStore();
    const commonFilter = store.commonFilter;
    const setCommonFilter = store.setCommonFilter;
    const getSubProject = async (projectId, key, userCode) => {
        try {
            const payload = {
                project_ids: projectId?.toString() || "",
                is_sub_project: !key ? true : key?.includes("is_sub_project") ? true : false,
                is_issue_type: !key ? true : key?.includes("is_issue_type") ? true : false,
                is_reporter: !key ? true : key?.includes("is_reporter") ? true : false,
                is_sprint: !key ? true : key?.includes("is_sprint") ? true : false,
                is_project_users: !key ? true : key?.includes("is_project_users") ? true : false,
                is_features: !key ? true : key?.includes("is_features") ? true : false,
                is_project_approver: !key ? true : key?.includes("is_approver") ? true : false,
                is_project_assignee: !key ? true : key?.includes("is_project_assignee") ? true : false,
            }
            const res = await services.getInvokeRemote("POST", Urls("GETPROJECTREPORTERSUBPROJECTDETAILS"), payload)
            if (!res?.body?.error_status) {
                const data = res?.body?.data
                const newFilters = { ...commonFilter, isChange: true };
                if (data?.reporter_detail && userCode) {
                    const userExists = _.filter(data?.reporter_detail, { reporter_user_code: userCode });
                    if (!_.isEmpty(userExists) && (_.isEmpty(newFilters.reporters) || !newFilters.reporters?.includes(userCode))) {
                        newFilters.reporters = [userCode];
                    } else {
                        newFilters.reporters = [];
                    }
                }
                if (data?.issue_type_detail && commonFilter.issueType) {
                    const validIssueTypes = data.issue_type_detail.map(item => item.issue_type_id);
                    newFilters.issueType = commonFilter.issueType.filter(id => validIssueTypes.includes(id));
                }

                if (data?.sprint_detail && commonFilter.sprint) {
                    const validIssueTypes = data.sprint_detail.map(item => item.sprint_id);
                    newFilters.sprint = commonFilter.sprint.filter(id => validIssueTypes.includes(id));
                }

                if (data?.sub_project_detail && commonFilter.subProject) {
                    const validSubProjects = data?.sub_project_detail?.map(item => item.option_id);
                    newFilters.subProject = commonFilter.subProject.filter(id => validSubProjects.includes(id));
                }

                if (data?.reporter_detail && !_.isEmpty(commonFilter.reporters)) {
                    const validReporters = data?.reporter_detail?.map(item => item.reporter_user_code);
                    newFilters.reporters = commonFilter.reporters.filter(id => validReporters.includes(id));
                }
                setCommonFilter(newFilters);
                return {
                    subProject: data?.sub_project_detail,
                    issueType: _.sortBy(data?.issue_type_detail, "issue_type_name"),
                    reporters: data?.reporter_detail,
                    sprint: data?.sprint_detail,
                    feature: data?.project_features_detail?.sort((a, b) => a?.issue_summary?.localeCompare(b?.issue_summary)),
                    projectUsers: data?.project_users_detail?.sort((a, b) => a?.user_display_name?.localeCompare(b?.user_display_name)),
                    approver: data?.project_approver_list_detail,
                    projectAssignee: data?.project_assignee_detail?.sort((a, b) => a?.user_display_name?.localeCompare(b?.user_display_name))?.filter(item => item?.user_display_name),
                }
            }
        } catch (error) {
            console.error("error:::", error)
        }
    }

    const getPriorityIcon = (priorityName) => {
        const priority = priorityName?.toLowerCase()
        let icon = {
            label: priority?.includes("very high") ? "angles-up" : priority?.includes("high") ? "arrow-up" : priority?.includes("medium") ? "equals" : priority?.includes("very low") ? "angles-down" : priority?.includes("low") ? "arrow-down" : "",
            class: priority?.includes("very high") ? "text-danger" : priority?.includes("high") ? "text-danger" : priority?.includes("medium") ? "text-warning" : priority?.includes("very low") ? "text-primary" : priority?.includes("low") ? "text-success" : ""
        };
        return (
            <div className={icon?.class}>{icon?.label && <FontAwesomeIcon icon={`fa-solid fa-${icon?.label}`} />}</div>
        )
    }

    const getEpicList = async (projects, setOptions) => {
        try {
            if (projects?.length > 0) {
                const projectIds = _.map(projects, p => p.project_id || p).join(',') || '';
                const payload = {
                    "project_ids": projectIds
                };
                const res = await services.getInvokeRemote('POST', Urls('GETEPIC'), payload);
                if (res?.body?.data?.epic_data) {
                    setOptions(prev => ({
                        ...prev,
                        epicList: _.sortBy(res.body.data.epic_data, 'issue_summary')
                    }));
                } else {
                    setOptions(prev => ({ ...prev, epicList: [] }));
                }
            } else {
                setOptions(prev => ({ ...prev, epicList: [] }));
            }
        } catch (error) {
            console.error("Epic list error:", error);
            setOptions(prev => ({ ...prev, epicList: [] }));
        }
    };

    const lockedLayoutFields = {
        "Description Fields": ["summary"],
        "Context Fields": ["status"]
    }

    const getUserInitials = (name, style) => {
        const initials = name?.split(" ")?.map((word) => word[0])?.join("")?.toUpperCase()?.slice(0, 2);
        const colors = ["#cd4141", "#71b3ae", "#d49f00", "#2c43a0", "#7e2994", "#02893b"];
        const bgColor = colors[name?.split("")?.reduce((acc, char) => acc + char?.charCodeAt(0), 0) % colors?.length];
        return (
            <div className="rounded-circle d-flex align-items-center justify-content-center text-white" style={{ width: 30, height: 30, backgroundColor: bgColor, fontSize: "14px", ...style}}>
                {initials}
            </div>
        )
    }

    return useMemo(() => ({
        getSubProject, getPriorityIcon, getEpicList, lockedLayoutFields, getUserInitials
    }), [getSubProject, getPriorityIcon, getEpicList, lockedLayoutFields, getUserInitials])
}